import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import {
  NitroDataGrid,
  NitroIcon,
  NitroModal,
  NitroParagraph
} from 'nitro-components';
import { media } from 'style-utils';
import { Badge } from 'material-ui';

import ActionsButtons from './ActionButtons';
import { getActionType, onActionSelect } from './store/action';
import {
  TransformText,
  GriddleActions,
  GridHeaderComponent,
  EllipsisText,
  GridBulkHeader
} from '../../components/utils/TableUtils';
import { NitroBadge } from 'nitro-components/build/nitro';
import AdminAPI from '../../api/AdminApi';
import { bindActionCreators } from 'redux';

const ResultGrid = styled.div`
  ${media.mobileTablet`
    display: none;
    & .griddle .standard-row td{
      padding: 10px 16px;
    }
    & .griddle .pagination .previous {
      margin: 0px 0px;
    }
    & .griddle .pagination .next {
      margin: 0px 0px;
    }
  `}

  & .griddle table {
    border-collapse: collapse;
    border-spacing: 0 15px;
    min-width: 1120px;
  }

  & .griddle .standard-row:last-child {
    border-bottom: 1px solid #d9d9d9;
  }
  & .griddle .standard-row {
    background-color: ${props => props.theme.color.white};
    border-radius: 2px;
    box-shadow: inset 0px 2px 0px 0 rgba(0, 0, 0, 0.15);
    width: 60px;
    height: 46px;
    border-bottom: none;
    &:hover {
      border: 2px solid ${props => props.theme.color.primary};
    }

    td:first-child {
      span {
        color: ${props => props.theme.color.primary};
        font-family: ${props => props.theme.font.default};
      }
    }

    td:nth-last-child(2) {
      color: ${props => props.theme.color.primary};
      font-family: ${props => props.theme.font.default};
    }
  }

  & .griddle .standard-row:nth-child(even) {
    background-color: ${props => props.theme.color.white};
  }

  & .griddle .griddle-column-bold {
    color: ${props => props.theme.color[props.variant]};
  }

  & .griddle {
    th {
      background-color: #e6eaef;
      text-transform: uppercase;
      font-family: ${props => props.theme.font.bold};
      color: ${props => props.theme.color.gunmetal};
      font-size: 11px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.82;
      letter-spacing: 0.4px;
    }
    & input[type='checkbox'] {
      width: 16px;
      height: 16px;
      border-radius: 4px;
      border: solid 1px var(--very-light-pink);
      background-color: #ffffff;
      cursor: pointer;
    }
  }

  & .griddle-footer .pagination {
    display: flex;
    align-items: center;
    align-content: center;
    & li {
      margin: 0;
      &.previous,
      &.next {
        padding: 9px 8px 3px 8px;
        vertical-align: -webkit-baseline-middle;
        & a {
          & svg {
            g {
              path {
                stroke: ${props => props.theme.color.primary};
              }
            }
          }
        }

        &:hover {
          border: 1px solid ${props => props.theme.color[props.variant]};
        }

        &:after,
        &:before {
          content: '';
          margin-right: 0px;
          margin-left: 0px;
          font: unset;
        }
      }

      &.active {
        background: ${props => props.theme.color.primary};
        color: ${props => props.theme.color.white};
        border: 1px solid #e6e6e6;
        padding: 6px 0px;
        border-radius: 2px;
      }

      &:hover {
        border: 1px solid ${props => props.theme.color[props.variant]};
      }
    }
    margin: 0;
  }

  & .griddle .footer-container {
    padding: 0;
    ${media.mobile`
      position: fixed;
      background: white;
    `}
  }
  & .griddle-footer > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
  }
  & .pagination li > a {
    color: ${props => props.theme.color.primary};
  }
`;

const ResultGridMobile = ResultGrid.extend`
  display: none;

  ${media.mobileTablet`
    display: block;
    & tbody {
      width: 100vw;
      max-height: 80vh;
      overflow: scroll;
    } 
  `}
  .griddle-footer > div {
    flex-direction: column;
    width: 100vw;
    & div {
      padding: 24px 0;
    }
    & ul {
      margin: 0 0 28px 0;
    }
  }
`;

const CustomBage = styled.div`
  padding: 0 !important;
  margin: 0 !important;
  & div {
    padding: 0 !important;
    margin: 0 !important;
    & span {
      width: 72px !important;
      height: 32px !important;
      position: relative !important;
      padding: 0 !important;
      margin: 0 !important;
      border-radius: 16px !important;
      background-color: ${props => props.theme.color[props.variant]} !important;
      color: ${props => props.theme.color.white} !important;
    }
  }
`;
const ModalContent = styled.div`
  width: 100%;
`;

class DetailedSearchResultsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allChecked: false,
      checkedUsers: [],
      showModal: false
    };
  }

  // For bulk actions
  checkUsers(user) {
    const users = this.state.checkedUsers;
    const index = users.map(x => x.userId).indexOf(user.userId);

    if (index !== -1) {
      users.splice(index, 1);
    } else {
      users.push(user);
    }
    if (this.props.actionType) {
      this.props.onActionSelect({ value: '' });
    }
    if (this.state.checkedUsers.length === this.props.data.length) {
      this.setState({ allChecked: true });
    } else {
      this.setState({ allChecked: false });
    }
    this.setState({ checkedUsers: users });
    return true;
  }
  columnMeta = [
    {
      columnName: 'userName',
      displayName: 'USER NAME',
      sortable: true,
      customHeaderComponent: GridHeaderComponent
    },
    {
      columnName: 'roles',
      displayName: 'Role',
      sortable: false,
      customComponent: ({ data }) => (
        <EllipsisText text={data.map(e => e.Name).join(',')} length={20} />
      )
    },
    {
      columnName: 'businessEntityName',
      displayName: 'BUSINESS ENTITY',
      sortable: true,
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => <EllipsisText text={data} length={15} />
    },
    {
      columnName: 'employerCompanyName',
      displayName: 'Company',
      sortable: true,
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => <EllipsisText text={data} length={15} />
    },
    {
      columnName: 'countryCode',
      displayName: 'COUNTRY',
      sortable: true,
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => (
        <EllipsisText text={data.toUpperCase()} length={10} />
      )
    },
    {
      columnName: 'status',
      displayName: 'STATUS',
      customHeaderComponent: GridHeaderComponent,
      customComponent: ({ data }) => (
        <GriddleActions
          length={20}
          content={
            <CustomBage
              variant={
                data !== 'Active'
                  ? data == 'Locked'
                    ? 'secondary'
                    : 'base2'
                  : 'primary'
              }
            >
              <Badge badgeContent={data} />
            </CustomBage>
          }
        />
      )
    },
    {
      columnName: 'actions',
      displayName: '  ',
      sortable: false,
      customHeaderComponent: () => (
        <GridBulkHeader
          checked={this.state.allChecked}
          onClick={e => {
            this.setState({
              allChecked: !this.state.allChecked,
              checkedUsers: this.state.allChecked ? [] : [...this.props.data]
            });
          }}
        />
      ),
      customComponent: data => (
        <span className="griddle-action">
          <GriddleActions
            content={
              <span>
                <NitroIcon
                  name="edit"
                  variant="secondary"
                  size={14}
                  right={12}
                  action={e => {
                    e.stopPropagation();
                    this.props.onDataRowClick(data, { editMode: true });
                  }}
                />
                <ActionsButtons
                  {...data}
                  {...this.props}
                  refresh={this.props.getExternalData}
                />
                <input
                  type="checkbox"
                  checked={
                    this.state.allChecked ||
                    this.state.checkedUsers
                      .map(x => x.userId)
                      .includes(data.rowData.userId)
                  }
                  onClick={e => {
                    e.stopPropagation();
                    this.checkUsers(data.rowData);
                  }}
                />
              </span>
            }
            style={{ minWidth: '50px', width: '35px' }}
          />
        </span>
      )
    }
  ];
  resetState(isRefresh) {
    if (isRefresh) {
      setTimeout(() => {
        this.props.getExternalData(this.props.currentPage);
      }, 1000);
    }
    this.setState({
      allChecked: false,
      checkedUsers: [],
      showModal: false
    });
    this.props.onActionSelect({ value: '' });
  }
  performAction() {
    setTimeout(() => {
      if (
        (this.props.actionType === 'Lock' ||
          this.props.actionType === 'Unlock' ||
          this.props.actionType === 'Reactivate' ||
          this.props.actionType === 'Terminate') &&
        this.state.checkedUsers.length
      ) {
        this.setState({ showModal: true });
      }
    }, 1500);
  }
  closeConfirmation() {
    this.props.onActionSelect({ value: '' });

    this.resetState();
  }
  lock = () => {
    this.closeConfirmation();
    AdminAPI.bulkLock(this.state.checkedUsers.map(x => x.userId))
      .then(res => {
        if (res.status == 200) {
          this.resetState(true);
        }
      })
      .catch(err => console.log(err));
  };
  unlock = () => {
    this.closeConfirmation();
    AdminAPI.bulkUnlock(this.state.checkedUsers.map(x => x.userId))
      .then(res => {
        if (res.status == 200) {
          this.resetState(true);
        }
      })
      .catch(err => console.log(err));
  };
  reactivate = () => {
    this.closeConfirmation();
    AdminAPI.bulkReactivate(this.state.checkedUsers.map(x => x.userId))
      .then(res => {
        if (res.status == 200) {
          this.resetState(true);
        }
      })
      .catch(err => console.log(err));
  };
  terminate = () => {
    this.closeConfirmation();
    AdminAPI.bulkTerminate(this.state.checkedUsers.map(x => x.userId))
      .then(res => {
        if (res.status == 200) {
          this.resetState(true);
        }
      })
      .catch(err => console.log(err));
  };
  render() {
    return (
      <div>
        {this.performAction()}
        <ResultGrid variant={this.props.variant}>
          <NitroDataGrid
            results={this.props.data}
            totalCount={this.props.total}
            columnMetaData={this.columnMeta}
            fetchExternalData={this.props.getExternalData}
            currentPage={this.props.currentPage}
            rowPerPage={this.props.rowCount}
            dataFetching={this.props.dataFetching}
            onRowClick={this.props.onDataRowClick}
          />
        </ResultGrid>
        <NitroModal
          title={`Confirm ${this.props.actionType} user `}
          action={() => this[this.props.actionType.toLowerCase()]()}
          actionLabel="Yes continue"
          cancelAction={() => this.closeConfirmation()}
          cancelLabel="No"
          isOpen={this.state.showModal}
          close={() => this.closeConfirmation()}
          messageFlexDirection="row"
        >
          <ModalContent>
            <NitroParagraph align="center">
              Are you sure you want to {this.props.actionType.toLowerCase()}{' '}
              selected users?
            </NitroParagraph>
            {this.state.checkedUsers.length > 0 &&
              this.state.checkedUsers.some(
                x => x.status !== this.state.checkedUsers[0].status
              ) && (
                <NitroParagraph align="center">
                  Some of your users you have selected have different status, do
                  you want to continue with this action?
                </NitroParagraph>
              )}

            <NitroParagraph align="center" />
          </ModalContent>
        </NitroModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actionType: getActionType(state)
});
const mapDispatchToProps = dispatch => ({
  onActionSelect: bindActionCreators(onActionSelect, dispatch)
});
DetailedSearchResultsGrid.propTypes = {
  dataFetching: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({})),
  total: PropTypes.number,
  rowCount: PropTypes.number,
  currentPage: PropTypes.number,
  variant: PropTypes.string,
  getExternalData: PropTypes.func,
  onDataRowClick: PropTypes.func,
  onActionSelect: PropTypes.func
};

DetailedSearchResultsGrid.defaultProps = {
  dataFetching: false,
  data: [],
  total: 0,
  rowCount: 0,
  currentPage: 0,
  variant: 'iceBlue',
  getExternalData: () => {},
  onDataRowClick: () => {},
  onActionSelect: () => {}
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailedSearchResultsGrid);



// WEBPACK FOOTER //
// ./src/features/userManagement/DetailedSearchResultsGrid.js